import { MultiValue, SingleValue } from 'react-select'

import { SelectOption } from '@/components'

export const ensureWronglyTypedLegacyCodeWorks = (value: number | string) => {
	return value as string
}

export const isMultiOption = (
	optionValue: MultiValue<SelectOption> | SingleValue<SelectOption>,
): optionValue is MultiValue<SelectOption> => Array.isArray(optionValue)

export const hasDataTestIdInProps = <T extends object>(
	componentProps: T,
): componentProps is T & { 'data-testid': string } =>
	'data-testid' in componentProps &&
	typeof componentProps['data-testid'] === 'string'
